"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { AspectRatio } from "@/components/ui/aspect-ratio";
export default function FundOverview() {
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: logoRef,
    isVisible: logoVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="bg-light-background py-16 sm:py-20 lg:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          {}
          <div ref={textRef} className={`transition-all duration-700 ease-smooth ${textVisible ? "opacity-100" : "opacity-0"}`}>
            <h2 className="text-3xl font-display font-bold text-foreground-light sm:text-4xl lg:text-5xl mb-6">
              Haven Holdings Capital
            </h2>
            <p className="text-lg text-foreground-light/80 leading-relaxed mb-6">A private‑equity real‑estate development fund creating turn‑key, purpose‑built properties for tenants in highly regulated sectors.</p>
            <p className="text-base text-foreground-light/70 leading-relaxed mb-6">
              We focus on risk‑adjusted returns through disciplined underwriting, targeted asset criteria, and value‑creation strategies. Our specialized approach centers on delivering turn‑key solutions that meet the exacting standards of regulated industries.
            </p>
            <div className="space-y-3">
              
              
              
            </div>
          </div>

          {}
          <div ref={logoRef} className={`transition-all duration-700 ease-smooth ${logoVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-16"}`}>
            <div className="mx-auto max-w-md lg:max-w-lg">
              <AspectRatio ratio={1 / 1}>
                <div className="w-full h-full border-2 border-border-strong rounded-md bg-muted flex items-center justify-center p-8">
                  <img src="https://picked-drum.10web.cloud/wp-content/uploads/2025/11/HHC.png" alt="Haven Holdings Capital Logo" className="w-full h-full object-contain" />
                </div>
              </AspectRatio>
            </div>
          </div>
        </div>
      </div>
    </section>;
}